import BillBox from './billbox.vue';
export default BillBox;


// WEBPACK FOOTER //
// ./src/components/billbox/index.js